// Carrinho da vitrine com o visual do Upcart da feminaglanz.shop (ver snippets/cart-drawer.liquid).
// 1) Barra Black Week: mostra a mensagem da fase do momento (datas em data-ini/data-fim) e a contagem real até o fim dela.
// 2) Versandschutz: a chave liga/desliga o produto "versandschutz"; a variante segue a faixa do subtotal
//    ("< €49,00", "< €99,00", "< €199,00", "€199,00 +"), igual ao Upcart, e sai sozinho se o carrinho esvaziar.
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  const tick = () => {
    const now = Date.now();
    document.querySelectorAll('[data-fg-bw] .fg-cart__bw-msg').forEach((msg) => {
      const fim = Date.parse(msg.dataset.fim);
      const on = now >= Date.parse(msg.dataset.ini) && now <= fim;
      if (msg.hidden === on) msg.hidden = !on;
      if (!on) return;
      const left = Math.max(0, Math.floor((fim - now) / 1000));
      const text = `${pad(Math.floor(left / 3600))}:${pad(Math.floor((left % 3600) / 60))}:${pad(left % 60)}`;
      msg.querySelectorAll('[data-fg-ate]').forEach((t) => {
        if (t.textContent !== text) t.textContent = text;
      });
    });
  };
  setInterval(tick, 1000);
  tick();

  // Versandschutz
  const toggle = () => document.querySelector('[data-fg-vs]');
  const tiers = (el) =>
    (el?.dataset.variants || '')
      .split(';')
      .filter(Boolean)
      .map((s) => {
        const [id, title] = s.split('|');
        // Só os dígitos do título, em centavos ("< €49,00" ou "< €49.00" = 4900).
        const limit = title.includes('<') ? parseInt(title.replace(/\D/g, ''), 10) : Infinity;
        return { id: Number(id), limit };
      });
  const tierFor = (list, subtotal) => (list.find((t) => subtotal < t.limit) || list[list.length - 1]).id;

  let busy = false;
  let known = null;

  const render = (state) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !state?.sections) return;
    if (drawer.classList.contains('active')) {
      drawer.renderContents(state);
      return;
    }
    const html = (id, selector) =>
      new DOMParser().parseFromString(state.sections[id], 'text/html').querySelector(selector)?.innerHTML;
    const inner = html('cart-drawer', '#CartDrawer');
    if (inner != null) document.getElementById('CartDrawer').innerHTML = inner;
    const bubble = document.getElementById('cart-icon-bubble');
    const bubbleHtml = html('cart-icon-bubble', '.shopify-section');
    if (bubble && bubbleHtml != null) bubble.innerHTML = bubbleHtml;
    drawer.classList.toggle('is-empty', state.item_count === 0);
    drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
  };

  const update = async (updates) => {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }),
    });
    if (!res.ok) throw new Error('cart update ' + res.status);
    return res.json();
  };

  // want: true = ligar, false = desligar, undefined = só acertar a faixa (ou tirar se o carrinho ficou só com ele).
  const sync = async (cart, want) => {
    const el = toggle();
    const list = tiers(el);
    if (!list.length || busy) return;
    busy = true;
    try {
      cart = cart || (await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json());
      const ids = list.map((t) => t.id);
      const mine = cart.items.filter((i) => ids.includes(i.variant_id));
      const others = cart.items.filter((i) => !ids.includes(i.variant_id));
      const on = want ?? mine.length > 0;
      const updates = {};
      mine.forEach((i) => (updates[i.variant_id] = 0));
      if (on && others.length) {
        const subtotal = others.reduce((s, i) => s + i.final_line_price, 0);
        updates[tierFor(list, subtotal)] = 1;
      }
      const same =
        Object.keys(updates).length === mine.length &&
        mine.every((i) => updates[i.variant_id] === 1 && i.quantity === 1);
      if (same || (!mine.length && !(on && others.length))) return;
      el?.closest('.fg-cart__addon')?.classList.add('is-busy');
      render(await update(updates));
    } catch (e) {
      console.warn('[fg-cart]', e);
      const box = toggle();
      if (box) box.checked = !box.checked;
    } finally {
      busy = false;
      toggle()?.closest('.fg-cart__addon')?.classList.remove('is-busy');
    }
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches?.('[data-fg-vs]')) sync(null, event.target.checked);
  });

  const listen = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      known = event?.cartData?.items ? event.cartData : null;
      // Depois de adicionar produto (product-form) o cartData não traz a lista inteira: lê o carrinho de novo.
      setTimeout(() => sync(known), 50);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      listen();
      sync();
    });
  } else {
    listen();
    sync();
  }
})();
